export default __webpack_public_path__ + "static/media/eMedHub.5ec3bb1d.jpeg";